import type { ConceptDef } from '../types';

export const echoicSentences: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-sentences',
  label: 'Echoic Sentences',
  category: 'Echoic',
  description: 'Speak a sentence; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'The dog is brown.' },
      { prompt: 'I see a red car.' },
      { prompt: 'She is eating an apple.' },
      { prompt: 'We are going to the park.' },
      { prompt: 'The cat is on the mat.' },
    ],
  },
};
